import { trimUserFields } from "../helpers/trimUserFields";
import {
  coreRoutes,
  idFlavor,
  OrganisationMembersListRes,
  OrgMemberWithAccessDetails,
  responseStatus,
  urlBuilder,
} from "@specsheet-common/shared-types";
import { orgMemberSubRoute } from "@specsheet-common/shared-types/dist/entities/orgMember/routes";
import { queryKeys } from "src/service/queryHooks/keys";
import { useQuery } from "src/service/reactQuery";

export const useQueryOrgUsers = (organisationId: idFlavor<"Organisation">) => {
  return useQuery<never, OrgMemberWithAccessDetails[]>({
    queryKey: queryKeys.orgUsers.fetchOrgUsers(organisationId),
    url: urlBuilder({
      root: coreRoutes.orgMember,
      sub: orgMemberSubRoute.list,
      tailParam: organisationId,
    }),
    responseFormatter(
      data: OrganisationMembersListRes
    ): OrgMemberWithAccessDetails[] {
      if (data.result === responseStatus.OK) {
        return data.data.map((user) => ({
          ...user,
          userProfile: trimUserFields(user.userProfile),
        }));
      }
      throw new Error("Could not fetch organisation users");
    },
  });
};
